export const LEGAL_PERSON = 'LEGAL_PERSON'
export const NATURAL_PERSON = 'NATURAL_PERSON'
